'use strict';

function updateFullNodeName() {
  this._fullNodeName = [this.parent._fullNodeName, this.nodeName]
    .filter(function notEmptyNames(name) { return name })
    .join('.');
}

function NamedNode(nodeName) {
  var name = nodeName ? String(nodeName) : '';

  Object.defineProperty(this, 'nodeName', {
    value: name,
    enumerable: true
  });
  this._fullNodeName = name;

  // If we have a parent, the parent plugin is available and we're not the root
  if (this.parent) {
    this.signals.onAncestryChanged.add(updateFullNodeName, this);
    updateFullNodeName.call(this);
  }
}

Object.defineProperties(NamedNode.prototype, {
  fullNodeName: {
    get: function fullNodeName() {
      if (this._checkAncestry) this._checkAncestry();
      return this._fullNodeName;
    },
    enumerable: true,
    configurable: true
  }
});

module.exports = {
  pluginName: 'nodeName',
  dependencies: ['parent'],

  nodeInit: NamedNode,
  nodeMethods: NamedNode.prototype
};



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/arborist/plugins/node_name.js
// module id = 715
// module chunks = 0